import { render, staticRenderFns } from "./CrmActiveFilters.vue?vue&type=template&id=0aad435c&scoped=true"
import script from "./CrmActiveFilters.vue?vue&type=script&lang=js"
export * from "./CrmActiveFilters.vue?vue&type=script&lang=js"
import style0 from "./CrmActiveFilters.vue?vue&type=style&index=0&id=0aad435c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aad435c",
  null
  
)

export default component.exports